export default import.meta.ROLLDOWN_FILE_URL_jaV0bQNxHc1aw3IeBmOC5w